import React, { useContext } from 'react';
import AppContext from '../contexts/AppContext';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ onClick }) => {
  const { theme } = useContext(AppContext);
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(); // 如果传入了自定义的 onClick，则调用自定义函数
    } else {
      navigate(-1); // 否则执行默认的返回操作
    }
  };
  const textColor = theme?.color ? 'rgb(255,255,255)' : (theme?.secondaryColor || theme?.topIcons ||'rgb(255,255,255)');

  return (
    <div
      className="fixed z-50 top-6 right-6 cursor-pointer flex-col items-center space-x-2"
      onClick={handleClick}
      style={{ color: textColor, fontColor: textColor }}
    >
      <ArrowLeftIcon className="w-6 h-6" style={{ marginLeft: '10px' }} />
      <p className="text-xs font-semibold">Back</p>
    </div>
  );
};

export default BackButton;
